// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"a153368f","168":"7f820904","250":"f7f1fd93","453":"29d12807","532":"b69ae639","534":"5442d9db","604":"85b84788","905":"b9171baa","906":"3344dc32","988":"bd860b23"}[chunkId] + ".chunk.js";
};